
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.06 8.636c2.102 0 4.002 1.078 5.091 2.564l2.582-2.6C21.19 6.592 18.217 5 15.061 5 9.533 5 5 9.473 5 15s4.533 10 10.06 10a9.986 9.986 0 009.619-7.273A9.694 9.694 0 0025.06 15v-.91H15.97v3.637h4.818a6.326 6.326 0 01-5.727 3.637c-3.51 0-6.425-2.855-6.425-6.364s2.916-6.364 6.425-6.364z","fill":"#fff"}})])
          )
        }
      }
    